export var FORMATTED_ADDRESS_FOUND_TEXT = 'Based on what you typed, we found this formatted address that is validated by the shipping provider.';